export const loginObject = (data) => {
  let wrapped = {
    email: data.email,
    password: data.password,
  };

  return wrapped;
};
